export const filter = {
  date: '',
  warehouse_id: '',
  // receiver_id: '',
  created_at: '',
  updated_at: ''
};